import React from "react";

const FilterBtnIcon = () => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<path
					d="M18.5 21.499L5 21.499"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27 21.499L23.5 21.499"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M21 23.999C22.3807 23.999 23.5 22.8797 23.5 21.499C23.5 20.1183 22.3807 18.999 21 18.999C19.6193 18.999 18.5 20.1183 18.5 21.499C18.5 22.8797 19.6193 23.999 21 23.999Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.5 10.4991L5 10.499"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M27 10.499L15.5 10.4991"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13 12.999C14.3807 12.999 15.5 11.8797 15.5 10.499C15.5 9.11831 14.3807 7.99902 13 7.99902C11.6193 7.99902 10.5 9.11831 10.5 10.499C10.5 11.8797 11.6193 12.999 13 12.999Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	);
};

export const FilterBtnIconV2 = () => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.999 3H1.99902L9.99902 12.46V19L13.999 21V12.46L21.999 3Z"
          stroke="#789B73"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default FilterBtnIcon;
